import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Collection } from '@helpers/show_page_helpers';
import './styles/main';

class SectionSort extends React.Component {
  renderSectionsButton = () => {
    const { editable } = this.props;
    const sectionsCopy = t('Sections');

    if (editable && BFG.context.hasFeature("manage_sections") && !Collection.key) {
      return (
        <button
          className="button tertiary edit section-pill j-manage-sections-link"
          type="button"
        >
          <span className="bff-edit-asset" />
          {sectionsCopy}
        </button>
      );
    }

    return <h3 className="sections-label">{`${sectionsCopy}:`}</h3>;
  }

  renderSectionsButtonsList = () => {
    const { activeSection, disabledSections, editable, sections, sectionsToShow } = this.props;
    const staticClasses = 'section-pill c-custom-border c-custom-opaque-background';

    const sectionButtons = sections.map((section) => {
      const disabledSection = disabledSections.includes(section.section_key);
      const sectionToShow = !sectionsToShow.includes(section.id);
      const isHidden = !editable && (sectionToShow || disabledSection) ? "hidden" : "";
      const isDisabled = disabledSections.includes(section.section_key) ? "disabled" : "";
      const isActive = section.id.toString() === activeSection ? "active" : "";

      return (
        <button
          className={`${staticClasses} ${isActive} ${isHidden} ${isDisabled}`}
          key={section.id}
          onClick={() => this.props.toggleActiveSection(section.id.toString())}
          type="button"
        >
          {section.name}
        </button>
      );
    });

    const allIsActive = activeSection === "all" ? "active" : "";
    const activeSectionClass = activeSection !== "all" ? "disabled" : "";

    return (
      <React.Fragment>
        <button
          className={`${staticClasses} ${allIsActive} ${activeSectionClass}`}
          onClick={() => this.props.toggleActiveSection("all")}
          type="button"
        >
          {t('All')}
        </button>
        {sectionButtons}
      </React.Fragment>
    );
  }

  renderSectionsDropdownList = () => {
    const { sections, activeSection, toggleActiveSection } = this.props;
    const selectAllOption = { value: 'all', label: 'All' };
    let selectedSection = selectAllOption;

    const options = sections.map((section) => {
      const active = activeSection === section.id.toString();
      const option = { value: section.id, label: section.name };

      if (active) {
        selectedSection = option;
      }

      return option;
    });

    options.unshift(selectAllOption);

    return (
      <div className="select-list-wrapper">
        <Select
          className="select-list"
          clearable={false}
          value={selectedSection}
          onChange={(e) => toggleActiveSection(e ? e.value.toString() : 'all')}
          options={options}
        />
      </div>
    );
  }

  render() {
    const { sectionDropdownSetting } = this.props;
    const displaySettingClass = sectionDropdownSetting
      ? 'display-sections-dropdown'
      : 'display-sections-buttons';

    return (
      <ul
        id="section-sort-list"
        className={`${displaySettingClass}`}
      >
        {this.renderSectionsButton()}
        {sectionDropdownSetting
          ? this.renderSectionsDropdownList()
          : this.renderSectionsButtonsList()}
      </ul>
    );
  }
}

SectionSort.propTypes = {
  activeSection: PropTypes.string.isRequired,
  disabledSections: PropTypes.arrayOf(PropTypes.string).isRequired,
  editable: PropTypes.bool.isRequired,
  sectionDropdownSetting: PropTypes.bool,
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    section_key: PropTypes.string,
  })).isRequired,
  sectionsToShow: PropTypes.arrayOf(PropTypes.number).isRequired,
  toggleActiveSection: PropTypes.func.isRequired
};

SectionSort.defaultProps = {
  sectionDropdownSetting: null
};

export default SectionSort;
